import { Post } from "../../shared/services/Fetch";
import { noHeadersResponse } from "../../shared/utils/Global";

export async function deleteDocs(docID: string, additionalDocData: any) {
  const headers = new Headers();
  if (additionalDocData.pageName) {
    headers.append("page-header", additionalDocData.pageName);
  } else {
    return noHeadersResponse();
  }
  let url = additionalDocData.isLenderPlatform
    ? `/lender/deleteDocs`
    : `/masterDashboard/deleteDocs`;
  const response = await Post(
    url,
    additionalDocData.token,
    {
      loanApplicationID: additionalDocData.loanID,
      docID
    },
    headers
  );

  if (response.status) {
    return true;
  } else {
    console.log(response.error);
  }

  return false;
}
